import { useTranslation } from 'react-i18next'

import type { OrganizationRole } from 'src/api/main'

import { ROLE_PALETTE } from '../utils'

type Props = {
  role: OrganizationRole
}

export const UsersRoleTag = ({ role }: Props) => {
  const { t } = useTranslation()
  const p = ROLE_PALETTE[role]

  return (
    <span
      style={{
        display: 'inline-flex',
        padding: '1px 8px',
        background: p.bg,
        color: p.color,
        borderRadius: 4,
        fontSize: 11,
        fontWeight: 500,
        lineHeight: 1.55
      }}
    >
      {t(`users.roles.${role}`)}
    </span>
  )
}
